<ngx-skeleton-loader
  *ngIf="docketLoading; else docketDetails"
  count="3"
  appearance="line"
></ngx-skeleton-loader>
<ng-template #docketDetails>
  <h1 data-cy="main-heading" *ngIf="docket.status === 'draft'; else finalized">
    Draft Sales Invoice {{ docket.id }}
  </h1>
  <ng-template #finalized>
    <h1 data-cy="main-heading">Sales Invoice {{ docket.invoice_number }}</h1>
    <app-key-value-pair
      name="Status"
      key="status-heading"
      [value]="docket.status | titlecase"
    ></app-key-value-pair>
    <p data-cy="finalized-details">
      <small
        >Finalized on
        {{ docket.finalized_at | amDateFormat: dateTimeFormat }}</small
      >
    </p>
  </ng-template>

  <div class="flex flex-row justify-center">
    <button
      matTooltip="Print"
      data-cy="print"
      color="primary"
      mat-icon-button
      (click)="print.emit(false)"
    >
      <mat-icon>print</mat-icon>
    </button>
    <button
      matTooltip="Download"
      color="primary"
      data-cy="download"
      mat-icon-button
      (click)="print.emit(true)"
    >
      <mat-icon>file_download</mat-icon>
    </button>
    <button
      matTooltip="Email"
      color="primary"
      data-cy="email"
      mat-icon-button
      (click)="email.emit()"
    >
      <mat-icon>send</mat-icon>
    </button>
  </div>
  <p data-cy="created-by">
    <small
      >Created on {{ docket.created_at | amDateFormat: dateTimeFormat }} by
      {{ docket.created_by | userIdToName | async }}</small
    >
  </p>
</ng-template>
